import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UseraccessserviceService } from '../services/useraccessservice.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard  {

  constructor(private router: Router, private useraccessservice: UseraccessserviceService) {

  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.authChecker(state);
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (state.url.includes('/user/userprofile')) {
      return true;
    }
    return this.authChecker(state);
  }

  authChecker(state: RouterStateSnapshot) {
    if (this.useraccessservice.getCurrentUserToken() != null || state.url.includes("/user/createschool?dat=")) {
      //debugger
      //let returnVal = this.checkUserSession(state.url);
      return true;
    } else {
      this.router.navigate(["/access/login"], { queryParams: { url: state.url } });
      return false;
    }
  }

  // checkUserSession(url) {
  //   var returnVal: boolean;
  //   if (url.includes("/user/createschool?dat=")) {
  //     return true;
  //   }
  //   var x = this.useraccessservice.isAlive().toPromise().then(
  //     (data: any) => {
  //       if (data) {
  //         this.useraccessservice.currentUser = data;
  //         return true;
  //       }
  //       else {
  //         console.log("loging user out now");
  //         this.router.navigate(["/access/login"]);
  //         return false;
  //       }
  //     },
  //     (err: HttpErrorResponse) => {
  //       console.log("loging user out now");
  //       this.router.navigate(["/access/login"]);
  //       return false;
  //     }
  //   );
  // }


  // canActivate( next: ActivatedRouteSnapshot,state: RouterStateSnapshot): boolean{
  //   let check : boolean;
  //   check = this.authChecker();
  //   console.log("activate : " + check)
  //   return check;
  // }

  // canActivateChild(next:ActivatedRouteSnapshot, state : RouterStateSnapshot) : boolean {
  //   let check : boolean;
  //   check = this.authChecker();
  //   console.log("activate child: " + check)
  //   return check;
  // }

  // authChecker(){
  //   console.log(this.useraccessservice.getCurrentUserToken() == null)
  //   if (this.useraccessservice.getCurrentUserToken() == null) {          
  //     this.router.navigate(["/access/login"]);  
  //     return false;
  //   } else {    
  //     this.useraccessservice.isAlive().toPromise().then(
  //       (data: any) => {         
  //         console.log("alovee")                                      
  //       return true;        

  //       },
  //       (err: HttpErrorResponse) => {
  //         this.router.navigate(["/access/login"]);  
  //         console.log("failed")    
  //         return false;
  //       }
  //     );
  //   }  

  // }

  // checkUserSession(){
  //               var returnVal: boolean;
  //               var x = 
  //                     console.log(returnVal);
  //                     return returnVal;    
  //                   }

}
